// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer-users-parent-page{
    position: relative;
}
.customer-users-page{
    margin: 0px;
    padding: 0px;
    height: 100vh;
    box-sizing: border-box;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
}
.customer-users-page-layout{
    height: 90%;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: auto 1fr;
}
.customer-users-parent-container{
    display: flex;
    align-items: center;
    justify-content: center;
}
.customer-users-container{
        width: 90%;
        height: 85%;
        padding: 2% 3%;
        border-radius: 5px;
        position: relative;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
}
@media screen and (max-width:949px){
    .customer-users-container{
        height: 78vh;
        margin-top: 2vh;
    }
}
.customer-users-header-container{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.customer-users-header-container h2{
    font-weight: lighter;
    color: rgb(90, 90, 90);
}
@media screen and (max-width:949px){
    .customer-users-header-container h2{
        font-size: 16px;
    }
}
.customer-users-header-controls{
    display: flex;
    align-items: center;
}
.add-new-customer-user-button{
    background-color: transparent;
    border: none;
    cursor: pointer;
    border-radius: 50%;
    padding: 2px 4px;
}
.add-new-customer-user-button:hover{
    background-color: rgb(214, 214, 214);
}
.add-new-customer-user-button img{
    height: 30px;
}
.refresh-customer-users-button{
    background-color: transparent;
    border: none;
    cursor: pointer;
    border-radius: 50%;
    padding: 5px 7px;
}
.refresh-customer-users-button:hover{
    background-color: rgb(214, 214, 214);
}
.refresh-customer-users-button img{
    height: 25px;
}

.customer-users-unavailable-container{
    display: flex;
    height: 70%;
    align-items: center;
    justify-content: center;
}

.customer-users-table-container{
    overflow: auto;
    max-height: 71.5vh;
}
.customer-users-table{
    width: 100%;
    border-collapse: collapse;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
}
.customer-users-table th, .customer-users-table td{
    text-align: left;
    padding: 10px 5px;
    white-space: nowrap;
}
@media screen and (max-width:949px){
    .customer-users-table th{
        font-size: 12px;
    }
}
.customer-users-table td{
    font-size: 12px;
}
#customer-users-table-header-row{
    color: black;
    background-color: transparent;
}
.customer-users-table tr:nth-child(even){
    cursor: pointer;
    background-color: rgb(242, 242, 242);
}
.customer-users-table tr:nth-child(odd){
    cursor: pointer;
    background-color: rgba(206, 206, 206, 0.952);
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/Customers/CustomerUsers/CustomerUsers.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,gDAAgD;AACpD;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,+BAA+B;AACnC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;QACQ,UAAU;QACV,WAAW;QACX,cAAc;QACd,kBAAkB;QAClB,kBAAkB;QAClB,sCAAsC;AAC9C;AACA;IACI;QACI,YAAY;QACZ,eAAe;IACnB;AACJ;AACA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,oBAAoB;IACpB,sBAAsB;AAC1B;AACA;IACI;QACI,eAAe;IACnB;AACJ;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,YAAY;AAChB;AACA;IACI,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,sCAAsC;AAC1C;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI;QACI,eAAe;IACnB;AACJ;AACA;IACI,eAAe;AACnB;AACA;IACI,YAAY;IACZ,6BAA6B;AACjC;AACA;IACI,eAAe;IACf,oCAAoC;AACxC;AACA;IACI,eAAe;IACf,4CAA4C;AAChD","sourcesContent":[".customer-users-parent-page{\r\n    position: relative;\r\n}\r\n.customer-users-page{\r\n    margin: 0px;\r\n    padding: 0px;\r\n    height: 100vh;\r\n    box-sizing: border-box;\r\n    font-family: Verdana, Geneva, Tahoma, sans-serif;\r\n}\r\n.customer-users-page-layout{\r\n    height: 90%;\r\n    box-sizing: border-box;\r\n    display: grid;\r\n    grid-template-columns: auto 1fr;\r\n}\r\n.customer-users-parent-container{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.customer-users-container{\r\n        width: 90%;\r\n        height: 85%;\r\n        padding: 2% 3%;\r\n        border-radius: 5px;\r\n        position: relative;\r\n        box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);\r\n}\r\n@media screen and (max-width:949px){\r\n    .customer-users-container{\r\n        height: 78vh;\r\n        margin-top: 2vh;\r\n    }\r\n}\r\n.customer-users-header-container{\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n.customer-users-header-container h2{\r\n    font-weight: lighter;\r\n    color: rgb(90, 90, 90);\r\n}\r\n@media screen and (max-width:949px){\r\n    .customer-users-header-container h2{\r\n        font-size: 16px;\r\n    }\r\n}\r\n.customer-users-header-controls{\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n.add-new-customer-user-button{\r\n    background-color: transparent;\r\n    border: none;\r\n    cursor: pointer;\r\n    border-radius: 50%;\r\n    padding: 2px 4px;\r\n}\r\n.add-new-customer-user-button:hover{\r\n    background-color: rgb(214, 214, 214);\r\n}\r\n.add-new-customer-user-button img{\r\n    height: 30px;\r\n}\r\n.refresh-customer-users-button{\r\n    background-color: transparent;\r\n    border: none;\r\n    cursor: pointer;\r\n    border-radius: 50%;\r\n    padding: 5px 7px;\r\n}\r\n.refresh-customer-users-button:hover{\r\n    background-color: rgb(214, 214, 214);\r\n}\r\n.refresh-customer-users-button img{\r\n    height: 25px;\r\n}\r\n\r\n.customer-users-unavailable-container{\r\n    display: flex;\r\n    height: 70%;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.customer-users-table-container{\r\n    overflow: auto;\r\n    max-height: 71.5vh;\r\n}\r\n.customer-users-table{\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);\r\n}\r\n.customer-users-table th, .customer-users-table td{\r\n    text-align: left;\r\n    padding: 10px 5px;\r\n    white-space: nowrap;\r\n}\r\n@media screen and (max-width:949px){\r\n    .customer-users-table th{\r\n        font-size: 12px;\r\n    }\r\n}\r\n.customer-users-table td{\r\n    font-size: 12px;\r\n}\r\n#customer-users-table-header-row{\r\n    color: black;\r\n    background-color: transparent;\r\n}\r\n.customer-users-table tr:nth-child(even){\r\n    cursor: pointer;\r\n    background-color: rgb(242, 242, 242);\r\n}\r\n.customer-users-table tr:nth-child(odd){\r\n    cursor: pointer;\r\n    background-color: rgba(206, 206, 206, 0.952);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
